import { jsx as _jsx } from "react/jsx-runtime";
import { useToast } from 'shared/components';
import { useTrackedDisclosure } from 'shared/features/analytics';
import { useDeleteNoteMutation } from 'shared/features/undo-note';
import { ToastErrorBox } from 'shared/components/features/ToastErrorBox';
import { useUnscheduledNoteForPathContext } from '../contexts';
import { useRedirectToInteractions } from './useRedirectToInteractions';
export var useDeleteNote = function () {
    var toast = useToast();
    var deleteConfirmDisclosure = useTrackedDisclosure('Delete Note', {
        spring_doc_id: 'compass017',
    });
    var redirect = useRedirectToInteractions();
    var noteId = useUnscheduledNoteForPathContext().noteId;
    var deleteMutation = useDeleteNoteMutation({
        onSuccess: function () {
            redirect();
        },
        onError: function (error) {
            var _a, _b;
            var message = (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message;
            toast({
                status: 'error',
                duration: 15000,
                position: 'top',
                render: function (_a) {
                    var onClose = _a.onClose;
                    return (_jsx(ToastErrorBox, { onClose: onClose, title: "Failed to delete note:", message: message }));
                },
            });
        },
    });
    var deleteNote = function () {
        if (noteId) {
            deleteMutation.mutate({ id: noteId !== null && noteId !== void 0 ? noteId : '' });
        }
        else {
            redirect();
        }
    };
    return {
        deleteConfirmDisclosure: deleteConfirmDisclosure,
        deleteNote: deleteNote,
        deleteMutation: deleteMutation,
    };
};
